import {Component, OnDestroy, OnInit} from '@angular/core';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {DepositService} from '../../../services/deposit/deposit.service';
import {UntypedFormControl} from '@angular/forms';
import {DepositState} from '../../../services/deposit/deposit.model';
import {MatSelectChange} from '@angular/material/select';
import {FilterStateDepositsData} from './filter-state-deposits.model';
import {StoreFilterService} from '../../../services/store/store-filter.service';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'app-filter-state-deposits',
  templateUrl: './filter-state-deposits.component.html',
  styleUrls: ['./filter-state-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterStateDepositsComponent extends HeaderFilterService implements OnInit, OnDestroy {
  stateControl = new UntypedFormControl([]);
  states: DepositState[] = [DepositState.WAITING, DepositState.ARCHIVED, DepositState.INCOMPLETE, DepositState.DONE];
  stateDefault: DepositState;
  subSink = new SubSink();
  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              public depositSvc: DepositService,
              private storeFiltersSvc: StoreFilterService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this._setStates();
    this._setDefaultState();
  }

  /**
   * Selon uniquement archivés ou non, les choix changent
   * @private
   */
  private _setStates() {
    this.subSink.sink = this.storeFiltersSvc.filters.subscribe(_filters => {
        this.states = _filters?.manager_archived ?
          this.states.filter(_filter => _filter === DepositState.ARCHIVED) :
          this.states.filter(_filter => _filter !== DepositState.ARCHIVED);
    });
  }
  onSelected(event: MatSelectChange) {
    this.stateDefault = event.value;
  }
  onCancel(event) {
  }

  onValidate(event) {
    const dataEmit = <FilterStateDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: this.stateDefault,
      condition: this.stateDefault ? `sur ${this.depositSvc.displayStateNames(this.stateDefault)}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.stateDefault = null;
    const dataEmit = <FilterStateDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }

  /**
   * Positionne l'état si déjà filtré sur ce dernier (this.data)
   * @private
   */
  private _setDefaultState() {
    if (this.data) {
      this.stateDefault = this.states.find(_state => _state === (<DepositState> this.data)) || null;
      if (this.stateDefault) {
        this.stateControl.patchValue(this.stateDefault);
      }
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
